<template>
  <el-main class="common-main">
    <div class="container">
      <div class="course-box">
        <div class="course-item">
          <div class="course-title">选择方向</div>
          <div class="course-list">
            <div class="course-list-item" :class="[directionId === 0 ? 'current' : '']" @click="selectDirection"
                 :data-id="0">
              全部
            </div>
            <div class="course-list-item" :class="[directionId === item.id ? 'current' : '']"
                 v-for="(item, index) in directions" :key="index" @click="selectDirection" :data-id="item.id">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="course-item" v-if="directionId">
          <div class="course-title">选择学科</div>
          <div class="course-list">
            <div class="course-list-item" :class="[subjectId === 0 ? 'current' : '']" @click="selectSubject"
                 :data-id="0">
              全部
            </div>
            <div class="course-list-item" :class="[subjectId === item.id ? 'current' : '']"
                 v-for="(item, index) in subjects" :key="index" @click="selectSubject" :data-id="item.id">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="course-item" v-if="subjectId">
          <div class="course-title">选择专业</div>
          <div class="course-list">
            <div class="course-list-item" :class="[subclassId === 0 ? 'current' : '']" @click="selectSubclass"
                 :data-id="0">
              全部
            </div>
            <div class="course-list-item" :class="[subclassId === item.id ? 'current' : '']"
                 v-for="(item, index) in subclasses" :key="index" @click="selectSubclass" :data-id="item.id">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
      <div class="study-box">
        <div class="study-nav">
          <div class="study-nav-list">
            <div class="study-nav-item" :class="[index === screenIndex ? 'current' : '']" v-for="(item, index) in screen"
                 :key="index" @click="changeScreen" :data-index="index">
              {{ item }}
            </div>
          </div>
          <div class="study-search">
            <el-input placeholder="搜索课程" v-model="keyword" class="input-with-select">
              <el-button slot="append" icon="el-icon-search" @click="searchStudy"></el-button>
            </el-input>
          </div>
        </div>
        <div class="study-list-box" v-loading="loading">
          <div class="study-list" v-if="studies.length > 0">
            <div class="study-item" v-for="(item, index) in studies" :key="index">
              <div class="study-item-left">
                <img :src="item.images && item.images.length > 0 ? path + item.images[0] : noneImg" :alt="item.title" class="study-item-img">
                <div class="study-item-info">
                  <div class="study-item-info-title" @click="goDetail(item.id)">{{ item.title }}</div>
                  <div class="study-item-info-tags">
                    <div class="study-item-info-tags-title">特色服务：</div>
                    <div class="study-item-info-tags-item" v-for="(i, n) in item.labels" :key="n">
                      {{ i.title }}
                    </div>
                  </div>
                  <div class="study-item-info-time">
<!--                    <i class="el-icon-time"></i>-->
<!--                    <span class="study-item-info-time-title">有效期至：{{-->
<!--                        $moment(item.end_time).format('YYYY-MM-DD')-->
<!--                      }}</span>-->
                    <i class="el-icon-s-custom"></i>
                    <span class="study-item-info-time-buy">已购买：{{ item.num }}</span>
                  </div>
                </div>
              </div>
              <div class="study-item-right">
                <div class="study-item-right-info">
                  <div class="study-item-price">¥{{ item.o_price }}</div>
                  <el-button plain class="study-item-intro" @click="goDetail(item.id)">查看详情</el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="empty" v-if="page_meta.total === 0">
            <div>
              <img src="../../static/images/empty.png" alt="暂无数据" class="empty-img">
              <div class="empty-title">暂无数据</div>
            </div>
          </div>
        </div>
        <div class="list-pagination" v-if="studies.length > 0">
          <el-pagination
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :page-size="page_meta.per_page"
              :total="page_meta.total">
          </el-pagination>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
import {request} from "@/utils/request";

export default {
  name: "courseIndex",
  head: {
    title: "选课中心"
  },
  data() {
    return {
      directions: [],
      directionId: 0,
      subjects: [],
      subjectId: 0,
      subclasses: [],
      subclassId: 0,
      studies: [],
      page: 1,
      screen: ['综合', '价格', '人气'],
      screenIndex: 0,
      loading: false,
      page_meta: [],
      path: process.env.VUE_APP_FILE,
      noneImg: process.env.VUE_APP_NONE,
      keyword: ''
    }
  },
  created() {
    this.getDirection(true)
    this.getStudy(true)
  },
  methods: {
    async getStudy(reset = false) {
      this.loading = true
      if (reset) {
        this.page = 1
      }
      try {
        let response = await request('course', {
          method: 'GET',
          params: {
            page: this.page,
            direction: this.directionId,
            subject: this.subjectId,
            subclass: this.subclassId,
            order: this.screenIndex,
            keyword: this.keyword
          }
        })
        let studies = response.data
        this.studies = studies.data
        this.page_meta = studies.meta
        this.loading = false
      } catch (e) {
        console.log(e)
      }
    },
    async getDirection(reset = false) {
      try {
        let response = await request('course/direction', {
          method: 'GET'
        })
        this.directions = response.data.data
      } catch (e) {

      }
    },
    async getSubject() {
      try {
        let response = await request('course/subject', {
          method: 'GET',
          params: {
            direction: this.directionId
          }
        })
        this.subjects = response.data.data
      } catch (e) {
        this.subclassId = 0
        this.subclasses = []
      }
    },
    async getSubclass() {
      try {
        let response = await request('course/subclass', {
          method: 'GET',
          params: {
            subject: this.subjectId
          }
        })
        let subclasses = response.data.data
        this.subclasses = subclasses
        if (reset) {
          this.subclassId = subclasses[0].id
        }
      } catch (e) {

      }
    },
    async searchStudy() {
      this.getStudy(true)
    },
    selectDirection(e) {
      let id = e.target.dataset.id
      this.directionId = parseInt(id)
      this.subjectId = 0
      this.getSubject()
      this.getStudy()
    },
    selectSubject(e) {
      let id = e.target.dataset.id
      this.subjectId = parseInt(id)
      this.subclassId = 0
      this.getSubclass()
      this.getStudy()
    },
    selectSubclass(e) {
      let id = e.target.dataset.id
      this.subclassId = parseInt(id)
      this.getStudy()
    },
    changeScreen(e) {
      let index = e.target.dataset.index
      this.screenIndex = parseInt(index)
      this.getStudy()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getStudy()
    },
    goDetail(val) {
      this.$router.push({path: '/course/' + val})
    }
  }
}
</script>

<style scoped>
.course-box {
  background-color: #ffffff;
  border-radius: 5px;
}

.course-item {
  position: relative;
  padding: 15px 15px 15px 0;
  border-bottom: 1px dashed #ebebeb;
}

.course-item:last-child {
  border-bottom: 0
}

.course-title {
  background-color: #2aacb2;
  color: #ffffff;
  position: absolute;
  top: 15px;
  left: 0;
  width: 100px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  padding-left: 15px;
  font-size: 16px;
}

.course-title:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  border-width: 17px;
  display: inline-block;
  border-style: solid;
  border-color: transparent transparent transparent #ffffff;
}

.course-title:after {
  content: '';
  position: absolute;
  top: 0;
  right: -35px;
  border-width: 17px;
  display: inline-block;
  border-style: solid;
  border-color: transparent transparent transparent #2aacb2;
}

.course-list {
  margin-left: 150px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  min-height: 34px;
}

.course-list-item {
  height: 34px;
  line-height: 34px;
  font-size: 14px;
  margin: 0 10px;
  cursor: pointer;
}

.course-list .current {
  color: #2aacb2;
  font-weight: bold;
}

.study-nav {
  background-color: #ffffff;
  display: flex;
  align-content: center;
  justify-content: space-between;
  font-size: 14px;
  border-radius: 5px;
}

.study-box {
  margin-top: 30px;
}

.study-nav-list{
  display: flex;
  align-content: center;
}

.study-nav-item {
  width: 80px;
  text-align: center;
  line-height: 40px;
  margin-left: 10px;
  cursor: pointer;
}

.study-nav-item:hover {
  background-color: #2aacb2;
  color: #ffffff;
}

.study-nav .current {
  background-color: #2aacb2;
  color: #ffffff;
}

.study-list-box {
  margin-top: 30px;
  background-color: #ffffff;
  min-height: 400px;
  border-radius: 5px;
}

.study-list {
  padding: 15px 10px;
}

.study-item {
  margin-bottom: 20px;
  padding: 10px;
  border-radius: 5px;
}

.study-item:last-child{
  margin-bottom: 0;
}

.study-item, .study-item:hover {
  -webkit-transition: all .3s ease;
  -moz-transition: all .3s ease;
  -o-transition: all .3s ease;
  transition: all .3s ease;
  display: flex;
  justify-content: space-between;
}

.study-item:hover {
  transform: translateY(-6px);
  -webkit-transform: translateY(-6px);
  -moz-transform: translateY(-6px);
  box-shadow: 0 26px 40px -24px rgba(0, 36, 100, .3);
  -webkit-box-shadow: 0 26px 40px -24px rgba(0, 36, 100, .3);
  -moz-box-shadow: 0 26px 40px -24px rgba(0, 36, 100, .3)
}

.study-item-left {
  width: 950px;
  display: flex;
}

.study-item-img {
  width: 280px;
  height: 180px;
  object-fit: cover;
  margin-right: 20px;
  border-radius: 5px;
}

.study-item-info {
  position: relative;
  width: 650px;
}

.study-item-info-title {
  cursor: pointer;
}

.study-item-info-title:hover {
  color: #2aacb2;
}

.study-item-info-tags {
  margin-top: 15px;
  font-size: 14px;
  color: #999999;
  display: flex;
  flex-wrap: wrap;
}

.study-item-info-tags-item {
  background-color: #2aacb2;
  color: #ffffff;
  margin-right: 5px;
  padding: 0 5px;
  border-radius: 3px;
  margin-bottom: 5px;
}

.study-item-info-time {
  color: #999999;
  font-size: 14px;
  position: absolute;
  left: 0;
  bottom: 0;
}

.study-item-info-time-title {
  margin-left: 5px;
}

.study-item-info-time-buy {
  margin-left: 5px;
}

.study-item-right {
  width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.study-item-right-info {
  text-align: center;
}

.study-item-price {
  font-size: 20px;
  color: #2aacb2;
  font-weight: bold;
}

.study-item-intro {
  margin-top: 20px;
}

.study-search{
  width: 300px;
}
</style>